import { render, staticRenderFns } from "./SetPairCombi.vue?vue&type=template&id=7523c41c&scoped=true&"
import script from "./SetPairCombi.vue?vue&type=script&lang=js&"
export * from "./SetPairCombi.vue?vue&type=script&lang=js&"
import style0 from "./SetPairCombi.vue?vue&type=style&index=0&id=7523c41c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7523c41c",
  null
  
)

export default component.exports